import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const getValueFromPath = (obj, path: string) => {
  const [key, ...accessors] = path.split('.');
  if (typeof obj[key] === 'object' && accessors.length) {
    return getValueFromPath(obj[key], accessors.join('.'));
  }
  return obj[key];
};

const concatPropertiesValue = (obj: object, paths: string[]): string => paths.reduce((searchString, path) =>
  `${getValueFromPath(obj, path)} ${searchString}`, '').toLowerCase();

export const filterAccessorsListWithMatch = (match: string) => (
  list$: Observable<object>,
  accessors: string[],
): Observable<object[]> =>
  list$.pipe(
    map(list => Object.values(list).filter(item => concatPropertiesValue(item, accessors).includes(match.toLowerCase()))),
  );
